/**
 * PC Remote Library
 * Author: Divya K
 * Created On: 14-08-2023
 */
export const KPI_VALUE_DECIMAL_PRECISION: number = 2;
  
  export const ConversionType = {
    ELECTRICITY: 'Electricity',
    GAS: 'Gas',
    WATER: 'Water',
    SEWERAGE: 'Sewerage',
    CARBON: 'Carbon'
  };